export function isDialogBackdropClick(event) {
  return event.target === event.currentTarget;
}

export function resetVideoPlayback(video) {
  if (!video) return;

  video.pause();
  video.currentTime = 0;
}

class NovaTestimonialVideoModal extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.nova-testimonials-section');
    this.dialog = this.querySelector('[data-nova-testimonial-dialog]');
    this.videoMount = this.querySelector('[data-nova-testimonial-video-mount]');
    this.closeButton = this.querySelector('[data-nova-testimonial-close]');

    if (!this.section || !this.dialog || !this.videoMount) return;

    this.section.addEventListener('click', this.handleSectionClick);
    this.closeButton?.addEventListener('click', this.handleCloseButtonClick);
    this.dialog.addEventListener('click', this.handleDialogClick);
    this.dialog.addEventListener('close', this.handleDialogClose);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('click', this.handleSectionClick);
    this.closeButton?.removeEventListener('click', this.handleCloseButtonClick);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.dialog?.removeEventListener('close', this.handleDialogClose);

    if (this.dialog?.open) this.dialog.close();
    this.cleanup(false);
  }

  open(trigger) {
    const templateId = trigger.dataset.videoTemplate;
    const template = templateId ? document.getElementById(templateId) : null;

    if (!template || template.tagName !== 'TEMPLATE') return;

    this.trigger = trigger;
    this.videoMount.replaceChildren(template.content.cloneNode(true));
    this.section.classList.add('is-video-open');
    document.documentElement.classList.add('nova-testimonial-dialog-open');

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    const playback = this.videoMount.querySelector('video')?.play();
    playback?.catch?.(() => {});
  }

  close() {
    if (this.dialog.open && typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.cleanup();
    }
  }

  cleanup(restoreFocus = true) {
    resetVideoPlayback(this.videoMount?.querySelector('video'));
    this.videoMount?.replaceChildren();
    this.section?.classList.remove('is-video-open');
    document.documentElement.classList.remove('nova-testimonial-dialog-open');

    if (restoreFocus) this.trigger?.focus();
    this.trigger = undefined;
  }

  handleSectionClick = (event) => {
    const trigger = event.target.closest?.('[data-nova-testimonial-play]');

    if (trigger && this.section.contains(trigger)) this.open(trigger);
  };

  handleCloseButtonClick = () => {
    this.close();
  };

  handleDialogClick = (event) => {
    if (isDialogBackdropClick(event)) this.close();
  };

  handleDialogClose = () => {
    this.cleanup();
  };
}

if (!customElements.get('nova-testimonial-video-modal')) {
  customElements.define('nova-testimonial-video-modal', NovaTestimonialVideoModal);
}
